module.exports = require("@swa-ui/core/src/Digit/Digit.module.scss");